import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface NoCMSModelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const NoCMSModel = ({ open, onOpenChange }: NoCMSModelProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[475px] bg-white p-0">
        <DialogHeader className="border-b px-6 py-6">
          <DialogTitle>{t("noCMSModalTitle")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 px-6">
          <p className="text-[14px] font-[500] font-[Raleway]">
            {t("noCMSModalDescription")}
          </p>
        </div>
        <DialogFooter className="flex justify-end gap-1 border-t pt-4 pb-4 px-6">
          <Button
            className="w-full"
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {t("returnHome")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NoCMSModel;
